export const COVER_PAGE_GET_PDF_FILE_START = 'COVER_PAGE_GET_PDF_FILE_START';
export const COVER_PAGE_GET_PDF_FILE_SUCCESS = 'COVER_PAGE_GET_PDF_FILE_SUCCESS';
export const COVER_PAGE_GET_PDF_FILE_FAIL = 'COVER_PAGE_GET_PDF_FILE_FAIL';
